import { useTranslation } from 'react-i18next';

import { OpportunityItemList } from '@/features/opportunities/types';
import { Table } from '@tanstack/react-table';
import { TableFilterDropdown } from './table-filter-dropdown';

export type TypeOfRevenueFilterProps = {
  readonly table: Table<OpportunityItemList>;
  readonly value?: string[];
  readonly onChange: (value: string[]) => void;
  readonly popoverFilter?: boolean;
};

const TYPE_OF_REVENUE_OPTIONS = [
  { label: 'Merchant', value: 'merchant' },
  { label: 'Contracted', value: 'contracted' },
];

export function TypeRevenueFilter({ table, value, onChange, popoverFilter }: TypeOfRevenueFilterProps) {
  const { t } = useTranslation(['home']);

  return (
    <TableFilterDropdown
      column={table.getColumn('typeOfRevenue')!}
      title={t('Type of Revenue')}
      options={TYPE_OF_REVENUE_OPTIONS}
      value={value}
      onChange={onChange}
      popoverFilter={popoverFilter}
    />
  );
}
